import { render, staticRenderFns } from "./ItemWithDifferentPrices.vue?vue&type=template&id=78b02c45&scoped=true"
import script from "./ItemWithDifferentPrices.vue?vue&type=script&lang=js"
export * from "./ItemWithDifferentPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b02c45",
  null
  
)

export default component.exports